import { Component } from '@angular/core';

import { MonthlyInvoice } from '../../../../../express-tRPC/src/api/monthly_invoices/types';
import { TrpcService } from '../../services/trpc/trpc.service';
import { MessageService } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';
import { dropdownOption } from '../../types/common';
import { Account, Suite } from '../../../../../express-tRPC/src/api/invoices/types';
import {environment} from '../../../environments/environment';


@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrl: './invoice-list.component.scss'
})
export class InvoiceListComponent {

  env = environment;
  invoices: MonthlyInvoice[] = [];
  totalInvoices: number = 0;
  isInvoicelistLoading: boolean = false;
  searchOptionsLoading: boolean = false;

  searchOptions: dropdownOption[] = [
    { name: "All Invoices", code: 'all' },
    { name: "Open Invoices", code: 'Open' },
    { name: "Invoices by Month", code: 'billingMonth' },
    { name: "Invoices by Date", code: 'date' },
    { name: "Invoices by Date Range", code: 'dateRange' },
    { name: "Invoices by Suite", code: 'suite' },
    { name: "Invoices by Suite / Account", code: 'suiteAcct' },
    { name: "Open Invoices by Suite", code: 'suiteOpen' },
    { name: "Open Invoices by Suite / Account", code: 'suiteAcctOpen' },
  ];
  suiteOptions: dropdownOption[] = [];
  suiteAcctOptions: dropdownOption[] = [];

  searchBy: string = 'Open';
  searchByBillingMonth: Date = new Date();
  searchByDate: Date = new Date();
  searchByRangeDates: Date[] = [new Date(), new Date()];
  searchBySuite: string = '';
  searchBySuiteAcct: string = '';

  minDate: Date;

  constructor(
    private trpcService: TrpcService,
    private messageService: MessageService
  ) {
    let date = new Date();

    this.minDate = new Date();
    this.minDate.setMonth(date.getMonth() + 1);
    this.minDate.setFullYear(date.getFullYear() - 5);

    this.getInvoices();
  }


  async getInvoices(event?: TableLazyLoadEvent) {

    // let limit = event?.rows || 10;
    // let offset = event?.first || 0;
    // let queryParams = {
    //   limit: limit,
    //   offset: offset,
    //   sortField: ((event?.sortField as string)  || ''),
    //   sortOrder: (event?.sortOrder || 0)
    // };

    this.isInvoicelistLoading = true;
    let invoicesResult: any = await this.trpcService.trpc.invoice.getInvoices.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    this.invoices = invoicesResult;
    this.totalInvoices = invoicesResult?.length || 0;
    // if(invoicesResult) {
    //   let count: any = await this.trpcService.trpc.invoice.getInvoicesCount.query().catch((error: any) => {
    //     this.messageService.add({
    //       severity: "error",
    //       detail: error.message,
    //     });
    //   });;
    //   this.totalInvoices = count?.length ? count[0]['COUNT(*)'] : 0;
    // }
    this.isInvoicelistLoading = false;
  }

  async searchInvoices() {

    this.isInvoicelistLoading = true;
    let searchdata: string = '';
    let searchDataSecond: string = '';

    if (this.searchBy == "billingMonth") {
      let month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      searchdata = (month[this.searchByBillingMonth.getMonth()] + "-" + this.searchByBillingMonth.getFullYear())
    }
    if (this.searchBy == "date") {
      searchdata = (this.searchByDate.getMonth() + 1) + "/" + this.searchByDate.getDate() + "/" + this.searchByDate.getFullYear();
    }

    if (this.searchBy == "dateRange") {
      searchdata = (this.searchByRangeDates[0].getMonth() + 1).toString().padStart(2, '0') + "/" + this.searchByRangeDates[0].getDate().toString().padStart(2, '0') + "/" + this.searchByRangeDates[0].getFullYear().toString().substr(-2);
      searchDataSecond = (this.searchByRangeDates[1].getMonth() + 1).toString().padStart(2, '0') + "/" + this.searchByRangeDates[1].getDate().toString().padStart(2, '0') + "/" + this.searchByRangeDates[1].getFullYear().toString().substr(-2);
    }

    if (this.searchBy == "suite" || this.searchBy == "suiteOpen" || this.searchBy == "suiteAcct" || this.searchBy == "suiteAcctOpen") {
      searchdata = this.searchBySuite;
      if (this.searchBy == "suiteAcct" || this.searchBy == "suiteAcctOpen") {
        searchDataSecond = this.searchBySuiteAcct;
      }
    }

    console.log(this.searchBy, searchdata, searchDataSecond)
    let invoicesResult: any = await this.trpcService.trpc.invoice.searchInvoice.query({ searchoption: this.searchBy, searchdata: searchdata, searchDataSecond: searchDataSecond }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    console.log(invoicesResult);
    this.invoices = invoicesResult;
    this.totalInvoices = invoicesResult?.length || 0;

    this.isInvoicelistLoading = false;
  }

  async getAccountBySuite(): Promise<void> {

    this.searchBySuiteAcct = '';
    this.suiteAcctOptions = [];

    if (this.searchBySuite && (this.searchBy == "suiteAcct" || this.searchBy == "suiteAcctOpen")) {

      this.searchOptionsLoading = true;

      let acctsResult: any = await this.trpcService.trpc.invoice.getAccounts.query({ suite: this.searchBySuite }).catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });
      if (acctsResult?.length) {
        this.suiteAcctOptions = acctsResult.map((acct: Account) => { return { code: acct.account_number, name: (acct.account_number + ' (' + acct.name + ')') } })
      }
      this.searchOptionsLoading = false;
    }
  }

  async getSearchOptions(event: any) {

    if ((event.value == "suite" || event.value == "suiteAcct" || event.value == "suiteOpen" || event.value == "suiteAcctOpen") && !this.suiteOptions?.length) {
      this.searchOptionsLoading = true;
      let suitesResult: any = await this.trpcService.trpc.invoice.getSuites.query().catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });
      if (suitesResult?.length) {
        this.suiteOptions = suitesResult.map((suite: Suite) => { return { code: suite.suite, name: suite.suite } })
      }
      this.searchOptionsLoading = false;
    }
  }
}
